export default "__VITE_ASSET__1K1HCVsP__"